import React from "react";
import CustomSelect from "./CustomSelect";
const currencyList = [
  {
    id: "1",
    value: "$",
  },
  {
    id: "2",
    value: "£",
  },
  {
    id: "3",
    value: "€",
  },
];
export default function Amount({ updateForm, form, onChangeInput }) {
  const changeMedium = (key) => (item) => updateForm({ [key]: item.value });
  const currencyListIndex = React.useMemo(() => {
    if (form.currency !== "") {
      return currencyList.findIndex((item) => item.value === form.currency);
    }
    return null;
  }, []);
  return (
    <div className="input__outer">
      <label htmlFor="">Amount</label>
      <div className="input__row">
        <div className="input amo">
          <input
            type="number"
            value={form.amount}
            onChange={onChangeInput("amount")}
          />
          <span className="curr">{form.currency}</span>
        </div>
        <CustomSelect
          list={currencyList}
          selected={currencyList[currencyListIndex]}
          onChange={changeMedium("currency")}
        />
      </div>
    </div>
  );
}
